import store from '@/store'
import useNotifications from '@/composables/useNotifications'
import { useRouter } from '@core/utils/utils'
import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import { useLambda } from '@/views/habit/awsLambda'
import { oid } from '@/helpers/mongoHelpers'
import { hasPermission } from '@/composables/usePermission'
import useAuditLog from '@/composables/useAuditLog'

export default function useBehaviourAdd() {
  const { showSuccessMessage, showErrorMessage } = useNotifications()
  const { router } = useRouter()
  const { createItem } = useLambda()
  const { createInitialAuditEntry } = useAuditLog()
  const userData = store.state?.userStore?.userData
  const behaviour = ref({ type: 'bool', expectedAnswer: true, requiresEvidence: false })
  const isSubmitting = ref(false)
  const collection = 'behaviour'

  const create = async (data) => {
    if (!hasPermission('task-behaviours', 'create')) {
      showErrorMessage(i18n.t('message.you_are_not_authorized'))
      return
    }

    isSubmitting.value = true

    try {
      const payload = {
        client_id: oid(userData.client.$oid),
        name: data.name.value,
        type: data.type.value,
        requiresEvidence: data.requiresEvidence.value,
        history: [createInitialAuditEntry()],
      }

      if (payload.type === 'bool') payload.expectedAnswer = data.expectedAnswer.value

      await createItem({ collection, payload })

      showSuccessMessage(i18n.t('message.behaviour_added'))
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.behaviour_add_error'))
    } finally {
      router.push({ name: 'organization-behaviour-list' })
      isSubmitting.value = false
    }
  }

  return {
    create,
    behaviour,
    isSubmitting,
  }
}
